module.exports = __webpack_public_path__ + "static/media/599.705493(5).1ff23a94.pdf";